export default '2025-03-01.dashboard';

//# sourceMappingURL=version.js.map